const yearsOptions = [
    {
        "text": "Years",
        "value": null,
        "disabled": true
    },
    {
        "text": "0 years",
        "value": "0"
    },
    {
        "text": "1 year",
        "value": "1"
    },
    {
        "text": "2 years",
        "value": "2"
    },
    {
        "text": "3 years",
        "value": "3"
    },
    {
        "text": "4 years",
        "value": "4"
    },
    {
        "text": "5 years",
        "value": "5"
    },
    {
        "text": "6 years",
        "value": "6"
    },
    {
        "text": "7 years",
        "value": "7"
    },
    {
        "text": "8 years",
        "value": "8"
    },
    {
        "text": "9 years",
        "value": "9"
    },
    {
        "text": "10 years",
        "value": "10"
    },
    {
        "text": "11 years",
        "value": "11"
    },
    {
        "text": "12 years",
        "value": "12"
    },
    {
        "text": "13 years",
        "value": "13"
    },
    {
        "text": "14 years",
        "value": "14"
    },
    {
        "text": "15 years",
        "value": "15"
    },
    {
        "text": "16 years",
        "value": "16"
    },
    {
        "text": "17 years",
        "value": "17"
    },
    {
        "text": "18 years",
        "value": "18"
    },
    {
        "text": "19 years",
        "value": "19"
    },
    {
        "text": "20 years",
        "value": "20"
    },
    {
        "text": "21 years",
        "value": "21"
    },
    {
        "text": "22 years",
        "value": "22"
    },
    {
        "text": "23 years",
        "value": "23"
    },
    {
        "text": "24 years",
        "value": "24"
    },
    {
        "text": "25 years",
        "value": "25"
    },
    {
        "text": "26 years",
        "value": "26"
    },
    {
        "text": "27 years",
        "value": "27"
    },
    {
        "text": "28 years",
        "value": "28"
    },
    {
        "text": "29 years",
        "value": "29"
    },
    {
        "text": "30 years",
        "value": "30"
    },
    {
        "text": "31 years",
        "value": "31"
    },
    {
        "text": "32 years",
        "value": "32"
    },
    {
        "text": "33 years",
        "value": "33"
    },
    {
        "text": "34 years",
        "value": "34"
    },
    {
        "text": "35 years",
        "value": "35"
    },
    {
        "text": "36 years",
        "value": "36"
    },
    {
        "text": "37 years",
        "value": "37"
    },
    {
        "text": "38 years",
        "value": "38"
    },
    {
        "text": "39 years",
        "value": "39"
    },
    {
        "text": "40 years",
        "value": "40"
    },
    {
        "text": "41 years",
        "value": "41"
    },
    {
        "text": "42 years",
        "value": "42"
    },
    {
        "text": "43 years",
        "value": "43"
    },
    {
        "text": "44 years",
        "value": "44"
    },
    {
        "text": "45 years",
        "value": "45"
    },
    {
        "text": "46 years",
        "value": "46"
    },
    {
        "text": "47 years",
        "value": "47"
    },
    {
        "text": "48 years",
        "value": "48"
    },
    {
        "text": "49 years",
        "value": "49"
    },
    {
        "text": "50 years",
        "value": "50"
    }
];
export default yearsOptions;
